export const experienceData = [
	{
		id: 1,
		company: "Cimpress India",
		jobtitle: "Software Engineer",
		startYear: "August 2023",
		endYear: "April 2026",
	},
	{
		id: 2,
		company: "Cimpress India",
		jobtitle: "Software Engineer Intern",
		startYear: "Feb 2023",
		endYear: "July 2023",
	},
	{
		id: 3,
		company: "Beyond Exams",
		jobtitle: "Software Engineer Intern",
		startYear: "May 2022",
		endYear: "July 2022",
	}
];
